// eslint-disable-next-line no-restricted-imports
import { Popover } from '@mui/material';

import { styled } from '../styled';
import { Colors } from '../theme';

import { PopoverClasses } from './types';

export const PopoverStyled = styled(Popover)(() => ({
  marginTop: 12,
  [PopoverClasses.paper]: {
    borderRadius: 8,
    boxShadow: 'none',
    border: `1px solid ${Colors.gray300}`,
  },
}));
